import { BooleanInput, coerceBooleanProperty, NumberInput } from '@angular/cdk/coercion';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { Directive, HostBinding, inject, Input, NgZone } from '@angular/core';
import { take } from 'rxjs';

@Directive({
  standalone: true,
  selector: `
    textarea[vsAutosize],
  `,
})
export class TextareaAutosizeDirective extends CdkTextareaAutosize {
  @HostBinding('class') get styles() {
    return `box-content`;
  }

  /** Whether autosizing is enabled or not */
  @Input('vsAutosize')
  override get enabled(): boolean {
    return super.enabled;
  }
  override set enabled(value: BooleanInput) {
    super.enabled = coerceBooleanProperty(value);
  }

  /** Minimum amount of rows in the textarea. */
  @Input('minRows')
  override get minRows(): number {
    return super.minRows;
  }
  override set minRows(value: NumberInput) {
    super.minRows = value;
  }

  /** Maximum amount of rows in the textarea. */
  @Input('maxRows')
  override get maxRows(): number {
    return super.maxRows;
  }
  override set maxRows(value: NumberInput) {
    super.maxRows = value;
  }

  private _ngZoneLocal = inject(NgZone);

  initialResize() {
    this._ngZoneLocal.onStable.pipe(take(1)).subscribe(() => this.resizeToFitContent(true));
  }
}
